import {ButtonProps} from "@FRAMEWORK/ui/types/d";
import styled from "@yb/styled-px2rem";

interface TextMoreButtonProps extends ButtonProps {
	isShow?: boolean;
}

const Button = styled.button<{$isActive: boolean}>`
	position: relative;
	display: inline-block;
	padding-right: 20px;
	background-color: #fff;
	color: var(--default-color);
	font-size: var(--small-size);
	font-family: "PT-regular";
	line-height: 1;

	&:before {
		position: absolute;
		top: ${props => (props.$isActive ? "4px" : "0")};
		right: 1px;
		display: block;
		width: 7px;
		height: 7px;
		border-top: 1px solid var(--default-color);
		border-left: 1px solid var(--default-color);
		background-color: transparent;
		transform: ${props => (props.$isActive ? "rotate(45deg)" : "rotate(225deg)")};
		content: "";
	}
`;

const TextMoreButton = ({onClick, isShow}: TextMoreButtonProps) => (
	<Button onClick={onClick} $isActive={isShow}>
		{isShow ? "접기" : "더보기"}
	</Button>
);

export default TextMoreButton;
